import { profileApi } from './../../config/api-url';
import { ApiService } from './api.service';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { ProfileService } from './profile.service';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PamtokenService implements Resolve<any> {

  constructor(
    private profileSer: ProfileService,
    private apiService: ApiService
  ) {}

  private formatErrors(error: any): Observable<never> {
    return throwError(error.error);
  }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.apiService.get(profileApi.getDataToken)
      .pipe(
        catchError(this.formatErrors)
      );
  }
}
